const filterObserver = (init = false) => {
    const peerFilterHolder = document.querySelector('[data-active-peer-group]');
    const activeTypeHelpHolder = document.querySelector('[data-active-type-help]');
    const activeTypeOfferHolder = document.querySelector('[data-active-offer]');
    const holder = document.querySelector('.suizidpraevention-locations-controls');
    const filterArray = [peerFilterHolder, activeTypeHelpHolder, activeTypeOfferHolder]
    let searchInput = holder.querySelector('.form-control');
    let loadMore = document.querySelector('.csp-list-load-more');

    let observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName.startsWith('data-active')) {
                /*if(mutation.attributeName === 'data-active-peer-group'){
                    console.log('peer group updated')
                }
                if(mutation.attributeName === 'data-active-type-help'){
                    console.log('type help updated')
                }
                if(mutation.attributeName === 'data-active-offer'){
                    console.log('type offer updated')
                }*/

                startRequest();
            }
        })

    });
    filterArray.forEach(filterBox => {
        observer.observe(filterBox, {
            attributes: true
        })
    })

    const startRequest = (isLoadMore  = false, tabChange = false) => {
        // Send Ajax Request for cards filter and trigger Map Marker rebuild
        // Find out which tab view is active
        let activeTab = holder.querySelector('.nav-link.active');
        let activeTabParent = activeTab.closest('.nav-tabs');
        let checkInitial = activeTabParent.getAttribute('data-inital-load');
        let activeAttribute = activeTab.getAttribute('data-bs-target');
        let peer = peerFilterHolder.getAttribute('data-active-peer-group');
        let helperType = activeTypeHelpHolder.getAttribute('data-active-type-help');
        let offerType = activeTypeOfferHolder.getAttribute('data-active-offer');

        let search = searchInput.value;

        /*if (checkInitial === 'true' && tabChange) {
            activeTabParent.setAttribute('data-inital-load', 'false');
            return;
        }*/
        if (activeAttribute === '#csp-list') {
            activeTabParent.setAttribute('data-inital-load', 'false');

            let step = 0;
            if(isLoadMore){
                step = parseInt(loadMore.getAttribute('data-current-step')) + 1;
            }
            handleAjax('get_places', peer, helperType, offerType, search, 'normal', 6, step);
        }
        if (activeAttribute === '#csp-map') {
            activeTabParent.setAttribute('data-inital-load', 'false');

            // do ajax for map side list and map rest stuff
            handleAjax('get_places', peer, helperType, offerType, search, 'small', -1, 0);

            // custom event to trigger map markers
            let mapEvent = new CustomEvent('filterChanged',  {
                bubbles: true,
                detail: {
                    peer:  peer,
                    helperType: helperType,
                    offerType: offerType,
                    search: search
                }

            });
            holder.dispatchEvent(mapEvent);
        }

    }

    // event listener for search field
    document.addEventListener('keypress', ev => {
        if (ev.key === 'Enter' && searchInput == document.activeElement) {
            startRequest();
        }
    })
    document.addEventListener('click', ev => {
        if(ev.target.closest('.csp-list-load-more')){
            startRequest(true);
        }
        else if (ev.target.closest('.form-search-input-button')){
            if (searchInput.value.length >= 0) {
                startRequest();
            }
        }else{
            return;
        }

    })
    searchInput.addEventListener('keyup', searchInputDebounce(() => {
        if (searchInput.value.length >= 3) {
            startRequest();


        }


    }, 800))

    function searchInputDebounce(callback, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(this, args);
            }, wait);
        };
    }

    // event listener if tabs are changed
    document.addEventListener('shown.bs.tab', ev => {
        startRequest(false, true);
    })
    const handleLockInput = (lock = true) => {
        // Lock all filter inputs until ajax request is done

        const navTabs = holder.querySelectorAll('.nav-link-map-tab');
        const dropDowns = holder.querySelectorAll('.dropdown-toggle');
        const checkboxHolders = holder.querySelectorAll('.csp-data-checkbox');
        const radios = holder.querySelectorAll('.csp-data-radio');
        const locationInput = holder.querySelector('.form-control');
        if (lock) {
            // Lock everything
            navTabs.forEach(t => t.disabled = true);
            dropDowns.forEach(t => t.disabled = true);
            checkboxHolders.forEach(t => {
                t.querySelector('input').disabled = true;
                t.querySelector('input').classList.add('disabled');
            });
            radios.forEach(t => {
                t.disabled = true;
                t.classList.add('disabled');
            });
            locationInput.disabled = true;
            locationInput.classList.add('disabled');
            loadMore.disabled = true;
        }
        if (!lock) {
            // Unlock everything
            navTabs.forEach(t => t.disabled = false);
            dropDowns.forEach(t => t.disabled = false);
            checkboxHolders.forEach(t => {
                t.querySelector('input').disabled = false;
                t.querySelector('input').classList.remove('disabled');
            });
            radios.forEach(t => {
                t.disabled = false;
                t.classList.remove('disabled');
            });
            locationInput.disabled = false;
            locationInput.classList.remove('disabled');
            loadMore.disabled = false;
        }
    }
    const handleAjax = (action, peer, help, offer, search, cardVersion = 'normal', load = 6, step = 0) => {
        const data = {
            action: action,
            csp_places_nonce: wp_environment.csp_places_nonce,
            help_for_cat: peer,
            type_of_help_cat: help,
            type_of_offer_cat: offer,
            card_version: cardVersion,
            search: search,
            load : load,
            step: step,


        };
        const spinners = document.querySelectorAll('.csp-list-tab-spinner');
        const counter = document.querySelector('.suizidpraevention-locations-count-present');
        handleLockInput();
        spinners.forEach(spinner =>{
            spinner.classList.remove('d-none');
        })
        let target = cardVersion === 'normal' ? '.csp-list-load-places' : '.suizidpraevention-tabs-map-pane-side-list';
        /*jQuery.post(wp_environment.csp_ajax_url, data, function (response) {

            if (response) {
                let split = response.split('splithere0DaolEasdasADSDERzz');
                let totalResults = parseInt(split[1]);
                if(step >= 0){
                    loadMore.setAttribute('data-current-step', step)
                    let tempStep = step + 1;
                    let possibleSteps = Math.ceil(totalResults / load);
                    if(possibleSteps > tempStep){

                        loadMore.classList.remove('d-none');
                        loadMore.classList.add('d-block');
                    }
                    if(possibleSteps <= tempStep){
                        loadMore.classList.add('d-none');
                        loadMore.classList.remove('d-block');
                    }

                }
                if(step === 0){
                    jQuery(target).html('');
                }
                jQuery(target).append(split[0]);
                jQuery('.suizidpraevention-locations-count-present').html('');
                jQuery('.suizidpraevention-locations-count-present').html(split[1]);
                handleLockInput(false);
                spinners.forEach(spinner =>{
                    spinner.classList.add('d-none');
                })
            }

        })*/
        let targetElement = document.querySelector(target);
        fetch(wp_environment.csp_ajax_url, {
            method: 'POST',
            headers:  {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data).toString(),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    let split = data.split('splithere0DaolEasdasADSDERzz');
                    let totalResults = parseInt(split[1]);
                    if(step >= 0){
                        loadMore.setAttribute('data-current-step', step)
                        let tempStep = step + 1;
                        let possibleSteps = Math.ceil(totalResults / load);
                        if(possibleSteps > tempStep){

                            loadMore.classList.remove('d-none');
                            loadMore.classList.add('d-block');
                        }
                        if(possibleSteps <= tempStep){
                            loadMore.classList.add('d-none');
                            loadMore.classList.remove('d-block');
                        }

                    }
                    if(step === 0){
                        targetElement.innerHTML = '';
                    }
                    targetElement.insertAdjacentHTML('beforeend', split[0]);
                    counter.innerHTML = '';
                    counter.append(split[1]);
                    handleLockInput(false);
                    spinners.forEach(spinner =>{
                        spinner.classList.add('d-none');
                    })
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }
    if(init){
        startRequest();
    }
}
export default filterObserver;

